import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
// import TextField from 'material-ui/TextField';
// import Toggle from 'material-ui/Toggle';

import { busTimelineData } from '../stores/busTimelineData'
// import moment from "moment"

// const styles = {
//   propContainer: {
//     width: 200,
//     overflow: 'hidden',
//     margin: '20px auto 0',
//   },
//   propToggleHeader: {
//     margin: '20px auto 10px',
//   },
// };

/**
 * A more complex example, allowing the table height to be set, and key boolean properties to be toggled.
 */
export default class TableExampleComplex extends Component {
  state = {
    fixedHeader: true,
    // fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    // height: '300px',
  };

  handleToggle = (event, toggled) => {
    this.setState({
      [event.target.name]: toggled,
    });
  };

  // onRowSelection = (rows) => {
  //   console.log('djeoiwdjoew',rows)
  //   const selectedData = []
  //   tableData.forEach((d, i) => {
  //           d.selected = rows.indexOf(i) > -1;
  //           selectedData.push(selectedData);
  //       });
  //    console.log(selectedData);
  // }

  render() {
    // console.log(moment().format())
    return (
      <div>
        <Table
          height={this.state.height}
          fixedHeader={this.state.fixedHeader}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
          // onRowSelection={this.onRowSelection}
        >
          <TableHeader
            displaySelectAll={this.state.showCheckboxes}
            adjustForCheckbox={this.state.showCheckboxes}
            enableSelectAll={this.state.enableSelectAll}
          >
            <TableRow>
              <TableHeaderColumn tooltip="">上午車<br/>關渡站</TableHeaderColumn>
              <TableHeaderColumn tooltip="">上午車<br/>和信</TableHeaderColumn>
              <TableHeaderColumn tooltip="">下午車<br/>關渡站</TableHeaderColumn>
              <TableHeaderColumn tooltip="">下午車<br/>和信</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
             {busTimelineData.map( (row, index) => (
              <TableRow key={index} >
                <TableRowColumn style={{overflow:'unset'}}>{row.mon_guan}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.mon_kfs}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.aft_guan}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.aft_kfs}</TableRowColumn>
              </TableRow>
              ))} 
          </TableBody>
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/busTable.js